import { render } from "./NavBar.vue?vue&type=template&id=2d73c64e"
import script from "./NavBar.vue?vue&type=script&lang=js"
export * from "./NavBar.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ambrosetemidayobako/Desktop/job/website/1.2.5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__